import api from '@shared/api';
import { ThunkAction } from 'redux-thunk';
import routes from '@root/routes';
import { Building, BuildingListing, StoreState, Action } from '@root/types';
import { fetchTourbookSummariesThunk } from '@store/actions/tourbooks/fetchTourbookSummaries';
import analyticsActions from './analyticsActions';
import otherActions from '../index';

const handleErrors = async response => {
  if (response.ok) return response;

  const errors = await response.json();
  throw Error(errors);
};
const ignoreErrors = () => {};

type ReceiveFetchBuilding = {
  type: 'RECEIVE_FETCH_BUILDING';
  payload: Building;
};
const receiveFetchBuilding = (building: Building): ReceiveFetchBuilding => ({
  type: 'RECEIVE_FETCH_BUILDING',
  payload: building,
});

type ReceiveFetchBuildingListings = {
  type: 'RECEIVE_FETCH_BUILDING_LISTINGS';
  payload: {
    listings: BuildingListing[];
    buildingSlug: string;
  };
};
const receiveFetchBuildingListings = (
  listings: BuildingListing[],
  buildingSlug: string,
): ReceiveFetchBuildingListings => ({
  type: 'RECEIVE_FETCH_BUILDING_LISTINGS',
  payload: { listings, buildingSlug },
});

// this is in this file since its the only place its called
// feel free to move if it gets a second
export const fetchBuildingListingsThunk =
  (slug: string): ThunkAction<void, StoreState, unknown, Action> =>
  dispatch => {
    api
      .fetch(routes.api.buildingListings(slug))
      .then(handleErrors)
      .then(response => response.json())
      .then((listings: BuildingListing[]) => {
        dispatch(receiveFetchBuildingListings(listings, slug));
      })
      .catch(ignoreErrors);
  };

const pageLoad =
  ({ slug, isPreview }): ThunkAction<void, StoreState, unknown, Action> =>
  async dispatch => {
    await dispatch(otherActions.setBuildingPage(slug, isPreview));

    if (isPreview) {
      dispatch(analyticsActions.buildingPageLoaded());
      return;
    }

    api
      .fetch(routes.api.building(slug))
      .then(handleErrors)
      .then(response => response.json())
      .then((building: Building) => {
        dispatch(receiveFetchBuilding(building));
        dispatch(fetchBuildingListingsThunk(slug));
        dispatch(fetchTourbookSummariesThunk());
        dispatch(analyticsActions.buildingPageLoaded());
      })
      .catch(ignoreErrors);
  };

export default pageLoad;

export type Actions = ReceiveFetchBuilding | ReceiveFetchBuildingListings;
